import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Tooltip from "@mui/material/Tooltip";
function formatNumber(value) {
  if (value >= 10000000) {
    // Convert to crore (10 million)
    return `${(value / 10000000).toFixed(2)} Cr`;
  } else if (value >= 100000) {
    // Convert to lakh (100 thousand)
    return `${(value / 100000).toFixed(2)} L`;
  } else if (value >= 1000) {
    // Convert to thousand
    return `${(value / 1000).toFixed(2)} K`;
  } else {
    // Return as is if below 1000
    return `${value}`;
  }
}
const Header = ({ totalSpent, jobsCreated, totalCampaign }) => {
  const stats = [
    {
      title: "Total Campaigns",
      value: totalCampaign,
      icon: "/assests/images/Campaigndash/Icon.png",
      description: "The total number of campaigns conducted so far.",
    },
    {
      title: "Total Spent",
      value: formatNumber(totalSpent),
      icon: "/assests/images/Campaigndash/Icon (1).png",
      description: "Total amount spent on all campaigns.",
    },
    {
      title: "Jobs Created",
      value: jobsCreated,
      icon: "/assests/images/Campaigndash/Icon (2).png",
      description: "Number of jobs created as a result of campaigns.",
    },
    // {
    //   title: "Recce average time",
    //   value: `0`,
    //   icon: "/assests/images/Campaigndash/Icon (3).png",
    //   description: "Average time taken for recce operations.",
    // },
    // {
    //   title: "Production average time",
    //   value: `0`,
    //   icon: "/assests/images/Campaigndash/Group 41.png",
    //   description: "Average time taken for production activities.",
    // },
  ];

  return (
    <div>
      <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 my-4">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="bg-white shadow-md rounded-xl p-4 flex items-center space-x-4 w-auto h-auto relative"
          >
            <img
              src={stat.icon}
              alt={stat.title}
              className="w-12 h-12 object-contain"
            />
            <div>
              <p className="text-gray-400 text-sm">{stat.title}</p>
              <p className="text-gray-800 font-semibold w-32 text-lg flex items-center justify-between gap-2">
                {stat.value}
              </p>
            </div>
            <Tooltip
              title={
                <div className="text-sm">
                  {/* <p className="font-semibold text-center text-gray-300">{stat.value}</p> */}
                  <p className="text-gray-300 text-center">
                    {stat.description}
                  </p>
                </div>
              }
              arrow
              placement="top"
            >
              <InfoOutlinedIcon
                fontSize="small"
                className="absolute right-1 top-1 text-gray-400 text-sm cursor-pointer"
              />
            </Tooltip>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Header;
